import { Input } from 'cd-eft/components/common/Input';
import { observer } from 'mobx-react';
import { Col, Row, Container } from 'reactstrap';
import React, { Fragment, useEffect, useRef } from 'react';
import { FormulaBanner } from '../Common/FormulaBanner';
import {
  InputContainer,
  ResultsContainer,
  DescriptionContainer,
  ImageContainer,
  FormulaPrintModalContainer,
} from '../template/FormulaFormTemplates';
import { SurfaceInletDrainageVM } from './SurfaceInletDrainageVM';
import { ComboBox } from 'cd-eft/components/common/ComboBox';
import { Loader } from 'cd-eft/components/common/LoadingSpinner/LoadingSpinner';
import { RadioGroup } from 'cd-eft/components/common/RadioGroup';
import { Checkbox } from 'cd-eft/components/common/Checkbox/Checkbox';
import { CustomInput } from 'reactstrap';
import './SurfaceInlet.scss';
import pdfLogo from 'cd-eft/assets/images/pdf-blue.svg';

const SurfaceInletDrainageComponent = (props) => {
  const vm = useRef(new SurfaceInletDrainageVM(props)).current;
  useEffect(() => {
    // on initial render, load form data - desc, img, help link
    vm.getFormData(`${props.section}_${props.title}_${props.id}`);
  }, []);
  return (
    <Fragment>
      <FormulaBanner title={vm.formulaTitle} help={vm.bannerHelpLink} />
      <div className="row formula-content surface-inlet-formula-content">
        <InputContainer
          computeCallback={() => {
            vm.computefnSurfaceInletDrainage();
          }}
          printCallback={() => {
            vm.launchAndExport();
          }}
          isLoading={vm.isLoading}
          disableCompute={vm.disableComputeBtn}
          disablePrint={!vm.hasResults || vm.isLoading || vm.disablePrintBtn}
        >
          <h2 className="sections-heading">Runoff</h2>
          <Container className='runoff-section-container'>
            <Row>
              <Col xs={6}>
                <Input
                  label="Drained Area (ac)"
                  idAndName="drained-area"
                  valid={!vm.formValidation.runoff.drainedArea}
                  value={vm.SurfaceInletDrainageFormData.runoff.drainedArea}
                  type="number"
                  onChange={(e) => {
                    vm.handleInputChange(e);
                  }}
                  step={0.01}
                  onBlur={(e) => vm.validateInput(e.target.name, e.target.value)}
                  className={vm.SurfaceInletDrainageErrorClass('drainedArea')}
                  onKeyDown={vm.handleOnKeyDown}
                  min={0}
                />
              </Col>
              <Col xs={6}>
                <ComboBox
                  idAndName="drainage-coefficient"
                  label="Drainage Coefficient"
                  aria-label="Drainage Coefficient"
                  valid={!vm.formValidation.runoff.drainageCoefficient}
                  value={vm.SurfaceInletDrainageFormData.runoff.drainageCoefficient}
                  onChange={(e) => {
                    vm.handleInputChange(e);
                  }}
                  onBlur={(e) => vm.validateInput(e.target.name, e.target.value)}
                  options={vm.SurfaceInletDrainageRunoffOptions}
                  errorMsg={''}
                  required={true}
                  className={vm.SurfaceInletDrainageErrorClass('drainageCoefficient')}
                />
              </Col>
            </Row>

            <Row>
              <Col xs={12} className="d-flex flex-column align-items-end">
                <Input
                  label="Qrequired (cfs) ="
                  idAndName="calculated-runoff"
                  ariaLabel="q required (cfs)"
                  valid={true}
                  value={vm.SurfaceInletDrainageFormData.runoff.qRequired}
                  onChange={() => { }}
                  wrapperClassName='calculated-middle'
                  className="usa-input border-0"
                  type="text"
                  readOnly
                />
                <button disabled={vm.disableComputeBtn} className="usa-button sub-btns" data-testid="input-container-button" onClick={() => vm.calSurfaceInletStaging(1)}>
                  Calculate Runoff
                </button>
              </Col>
            </Row>
          </Container>
          <h2 className="sections-heading">Elevations</h2>
          <Container className='elevations-section-container'>
            <Row>
              <Col xs={6}>
                <Input
                  label="Water Elevation (ft)"
                  idAndName="water-elevation"
                  valid={!vm.formValidation.elevations.waterElev}
                  value={vm.SurfaceInletDrainageFormData.elevations.waterElev}
                  type="number"
                  onChange={(e) => {
                    vm.handleInputChange(e);
                  }}
                  step={0.01}
                  onBlur={(e) => vm.validateInput(e.target.name, e.target.value)}
                  className={vm.SurfaceInletDrainageErrorClass('waterElev')}
                  onKeyDown={vm.handleOnKeyDown}
                  min={0}
                />
              </Col>
              <Col xs={6}>
                <Input
                  label="Soil Elevation at Riser (ft)"
                  idAndName="soil-elevation-riser"
                  valid={!vm.formValidation.elevations.soilElevRiser}
                  value={vm.SurfaceInletDrainageFormData.elevations.soilElevRiser}
                  type="number"
                  onChange={(e) => {
                    vm.handleInputChange(e);
                  }}
                  step={0.01}
                  onBlur={(e) => vm.validateInput(e.target.name, e.target.value)}
                  className={vm.SurfaceInletDrainageErrorClass('soilElevRiser')}
                  onKeyDown={vm.handleOnKeyDown}
                  min={0}
                />
              </Col>
            </Row>
            <Row>
              <Col xs={6}>
                <Input
                  label="Main-Line Elevation (ft)"
                  idAndName="main-line-elevation"
                  valid={!vm.formValidation.elevations.mainLineElevation}
                  value={vm.SurfaceInletDrainageFormData.elevations.mainLineElevation}
                  type="number"
                  onChange={(e) => {
                    vm.handleInputChange(e);
                  }}
                  step={0.01}
                  onBlur={(e) => vm.validateInput(e.target.name, e.target.value)}
                  className={vm.SurfaceInletDrainageErrorClass('mainLineElevation')}
                  onKeyDown={vm.handleOnKeyDown}
                  min={0}
                />
              </Col>
              <Col xs={6}>
                <Input
                  label="Main-Line Diameter (in)"
                  idAndName="main-line-diameter"
                  valid={!vm.formValidation.elevations.mainLineDiameter}
                  value={vm.SurfaceInletDrainageFormData.elevations.mainLineDiameter}
                  type="number"
                  onChange={(e) => {
                    vm.handleInputChange(e);
                  }}
                  step={0.01}
                  onBlur={(e) => vm.validateInput(e.target.name, e.target.value)}
                  className={vm.SurfaceInletDrainageErrorClass('mainLineDiameter')}
                  onKeyDown={vm.handleOnKeyDown}
                  min={0}
                />
              </Col>
            </Row>
          </Container>

          <h2 className="sections-heading margin-subhead">Riser Material</h2>
          <Container className='riser-material-section-container'>
            <Row>
              <Col xs={7}>
                <ComboBox
                  idAndName="rm-material"
                  label="Material"
                  aria-label="material"
                  valid={!vm.formValidation.riserMaterial.rmMaterial}
                  value={vm.SurfaceInletDrainageFormData.riserMaterial.rmMaterial}
                  onChange={(e) => {
                    vm.handleInputChange(e);
                  }}
                  onBlur={(e) => vm.validateInput(e.target.name, e.target.value)}
                  options={vm.SurfaceInletDrainageRmMaterialOptions}
                  errorMsg={''}
                  required={true}
                  className={vm.SurfaceInletDrainageErrorClass('rmMaterial')}
                  wrapperName='material-input'
                />
              </Col>
              <Col xs={5} className='p-0'>
                <Checkbox
                  id="rm-perforated"
                  classAdmin="checkbox-input-formulas"
                  label="Perforated"
                  checked={vm.SurfaceInletDrainageFormData.riserMaterial.perforated}
                  name="rm-perforated"
                  onChange={(e) => {
                    vm.toggleEnableDisableInputs(e.target.name);
                  }}
                />

              </Col>
            </Row>
            <Row>
              <Col xs={7}>
                {vm.SurfaceInletDrainageFormData.riserMaterial.rmMaterial === 'USER_DEFINED' ?
                  <Input
                    label="Pipe Size (in)"
                    idAndName="rm-pipe-size-box"
                    valid={!vm.formValidation.riserMaterial.rmPipeSize}
                    value={vm.SurfaceInletDrainageFormData.riserMaterial.rmPipeSize}
                    type="number"
                    onChange={(e) => {
                      vm.handleInputChange(e);
                    }}
                    step={0.01}
                    onBlur={(e) => vm.validateInput(e.target.name, e.target.value)}
                    className={vm.SurfaceInletDrainageErrorClass('rmPipeSize')}
                    wrapperClassName='pipe-size-input'
                    onKeyDown={vm.handleOnKeyDown}
                    min={0}
                  />
                  :
                  <ComboBox
                    idAndName="rm-pipe-size"
                    label="Pipe Size (in)"
                    aria-label="pipe size"
                    valid={!vm.formValidation.riserMaterial.rmPipeSize}
                    value={vm.SurfaceInletDrainageFormData.riserMaterial.rmPipeSize}
                    onChange={(e) => {
                      vm.handleInputChange(e);
                    }}
                    onBlur={(e) => vm.validateInput(e.target.name, e.target.value)}
                    options={vm.SurfaceInletDrainageRmPipesizeOptions}
                    errorMsg={''}
                    required={true}
                    className={vm.SurfaceInletDrainageErrorClass('rmPipeSize')}
                    wrapperName='pipe-size-input'
                  />
                }

              </Col>
              <Col xs={5} className='p-0'>
                <Checkbox
                  id="rm-pressurizable"
                  classAdmin="checkbox-input-formulas"
                  label="Pressurizable"
                  checked={vm.SurfaceInletDrainageFormData.riserMaterial.pressurizable}
                  name="rm-pressurizable"
                  onChange={(e) => {
                    vm.toggleEnableDisableInputs(e.target.name);
                  }}
                />
              </Col>
            </Row>
            <Row>
              <Col xs={6}>
                <Input
                  label="Manning's n"
                  idAndName="rm-manningsn"
                  valid={!vm.formValidation.riserMaterial.rmManningsn}
                  value={vm.SurfaceInletDrainageFormData.riserMaterial.rmManningsn}
                  type="number"
                  onChange={(e) => {
                    vm.handleInputChange(e);
                  }}
                  step={0.0001}
                  onBlur={(e) => vm.validateInput(e.target.name, e.target.value)}
                  className={vm.SurfaceInletDrainageErrorClass('rmManningsn')}
                  onKeyDown={vm.handleOnKeyDown}
                  min={0}
                />
              </Col>
            </Row>
          </Container>
          <h2 className="sections-heading margin-subhead">Inlet Top</h2>
          <Container className='inlet-top-section-container'>
            <Row>
              <Col xs='auto' className='p-0'>
                <ComboBox
                  idAndName="guard"
                  label="Guard"
                  aria-label="Guard"
                  valid={!vm.formValidation.inletTop.guard}
                  value={vm.SurfaceInletDrainageFormData.inletTop.guard}
                  onChange={(e) => {
                    vm.handleInputChange(e);
                  }}
                  onBlur={(e) => vm.validateInput(e.target.name, e.target.value)}
                  options={vm.SurfaceInletDrainageInletTopOptions}
                  errorMsg={''}
                  required={true}
                  className={vm.SurfaceInletDrainageErrorClass('guard')}
                  wrapperName='guard-input'
                />
              </Col>
              <Col xs={4}>
                <Input
                  label="Top Opening (in)"
                  idAndName="top-opening"
                  valid={!vm.formValidation.inletTop.topOpening}
                  value={vm.SurfaceInletDrainageFormData.inletTop.topOpening}
                  disabled={!vm.SurfaceInletDrainageFormData.inletTop.enableTopOpening}
                  type="number"
                  onChange={(e) => {
                    vm.handleInputChange(e);
                  }}
                  step={0.01}
                  onBlur={(e) => vm.validateInput(e.target.name, e.target.value)}
                  className={vm.SurfaceInletDrainageErrorClass('topOpening')}
                  onKeyDown={vm.handleOnKeyDown}
                  min={0}
                />
              </Col>
              <Col xs={4}>
                <Input
                  label="Plugged Fraction"
                  idAndName="plugged-fraction"
                  valid={!vm.formValidation.inletTop.pluggedFraction}
                  value={vm.SurfaceInletDrainageFormData.inletTop.pluggedFraction}
                  type="number"
                  onChange={(e) => {
                    vm.handleInputChange(e);
                  }}
                  step={0.01}
                  onBlur={(e) => vm.validateInput(e.target.name, e.target.value)}
                  className={vm.SurfaceInletDrainageErrorClass('pluggedFraction')}
                  wrapperClassName='plugged-fraction-input'
                  onKeyDown={vm.handleOnKeyDown}
                  min={0}
                />
              </Col>
            </Row>
            <Row>
              <Col xs={12} className="d-flex flex-column align-items-end">
                <Input
                  label="Qtop (cfs) ="
                  idAndName="q-top"
                  ariaLabel="q top (cfs)"
                  valid={true}
                  value={vm.SurfaceInletDrainageFormData.inletTop.qTop}
                  onChange={() => { }}
                  wrapperClassName='calculated-middle'
                  className="usa-input border-0"
                  type="text"
                  readOnly
                />
                <button disabled={vm.disableComputeBtn} className="usa-button sub-btns" data-testid="input-container-button" onClick={() => vm.calSurfaceInletStaging(2)}>
                  Calculate Inlet Top
                </button>
              </Col>
            </Row>
          </Container>

          <h2 className="sections-heading">Riser Perforations</h2>
          <RadioGroup
            labelId="surface-inlet-radio"
            items={[
              {
                id: 'round-perf',
                name: 'round-perf',
                label: 'Round Perf',
                className: 'usa-radio__input--tile',
                checked: vm.roundPerfControl,
                onChange: vm.handleInputChange,
              },
              {
                id: 'rectangular-perf',
                name: 'rectangular-perf',
                label: 'Rectangular Perf',
                className: 'usa-radio__input--tile',
                checked: vm.rectangularPerfControl,
                onChange: vm.handleInputChange,
              },
            ]}
          />
          <Container className='riser-perforations-section-container'>
            <Row>
              <Col xs='auto' className='p-0'>
                <Input
                  label="Holes per ft"
                  idAndName="holes-per-ft"
                  valid={!vm.formValidation.riserPerforations.holesPerft}
                  value={vm.SurfaceInletDrainageFormData.riserPerforations.holesPerft}
                  type="number"
                  onChange={(e) => {
                    vm.handleInputChange(e);
                  }}
                  step={0.01}
                  onBlur={(e) => vm.validateInput(e.target.name, e.target.value)}
                  className={vm.SurfaceInletDrainageErrorClass('holesPerft')}
                  wrapperClassName='holes-per-input'
                  onKeyDown={vm.handleOnKeyDown}
                  min={0}
                />
              </Col>
              <Col xs={4}>
                <Input
                  label="Height (ft)"
                  idAndName="height"
                  valid={!vm.formValidation.riserPerforations.height}
                  value={vm.SurfaceInletDrainageFormData.riserPerforations.height}
                  type="number"
                  onChange={(e) => {
                    vm.handleInputChange(e);
                  }}
                  step={0.01}
                  onBlur={(e) => vm.validateInput(e.target.name, e.target.value)}
                  className={vm.SurfaceInletDrainageErrorClass('height')}
                  onKeyDown={vm.handleOnKeyDown}
                  min={0}
                />
              </Col>
              <Col xs={4}>
                <Input
                  label="Plugged Perf. Fraction"
                  idAndName="plugged-perf-fraction"
                  valid={!vm.formValidation.riserPerforations.perfFraction}
                  value={vm.SurfaceInletDrainageFormData.riserPerforations.perfFraction}
                  type="number"
                  onChange={(e) => {
                    vm.handleInputChange(e);
                  }}
                  step={0.01}
                  onBlur={(e) => vm.validateInput(e.target.name, e.target.value)}
                  className={vm.SurfaceInletDrainageErrorClass('perfFraction')}
                  wrapperClassName='plugged-perf-fraction'
                  onKeyDown={vm.handleOnKeyDown}
                  min={0}
                />
              </Col>

            </Row>

            <Row>
              {vm.surfaceInletRadioControl === 0 &&
                <Col xs='auto' className='p-0'>
                  <Input
                    label="Perf. Diam (in)"
                    idAndName="perf-diam"
                    valid={!vm.formValidation.riserPerforations.perfDiameter}
                    value={vm.SurfaceInletDrainageFormData.riserPerforations.perfDiameter}
                    className={vm.SurfaceInletDrainageErrorClass('perfDiameter')}
                    wrapperClassName='perf-diam-input'
                    type="number"
                    step={'0.01'}
                    onChange={(e) => {
                      vm.handleInputChange(e);
                    }}
                    onBlur={(e) => vm.validateInput(e.target.name, e.target.value)}
                    onKeyDown={vm.handleOnKeyDown}
                    min={0.01}
                  />
                </Col>}
              {vm.surfaceInletRadioControl === 1 &&
                <>
                  <Col xs='auto' className='p-0'>
                    <Input
                      label="Perf. Width (in)"
                      idAndName="perf-width"
                      valid={!vm.formValidation.riserPerforations.perfWidth}
                      value={vm.SurfaceInletDrainageFormData.riserPerforations.perfWidth}
                      className={vm.SurfaceInletDrainageErrorClass('perfWidth')}
                      wrapperClassName='perf-width-input'
                      type="number"
                      step={'0.01'}
                      min={0.01}
                      onChange={(e) => vm.handleInputChange(e)}
                      onBlur={(e) => vm.validateInput(e.target.name, e.target.value)}
                      onKeyDown={vm.handleOnKeyDown}
                    />
                  </Col>
                  <Col xs={4}>
                    <Input
                      label="Height (in)"
                      idAndName="perf-height"
                      valid={!vm.formValidation.riserPerforations.perfHeight}
                      value={vm.SurfaceInletDrainageFormData.riserPerforations.perfHeight}
                      className={vm.SurfaceInletDrainageErrorClass('perfHeight')}
                      type="number"
                      step={'0.01'}
                      min={0.01}
                      onChange={(e) => vm.handleInputChange(e)}
                      onBlur={(e) => vm.validateInput(e.target.name, e.target.value)}
                      onKeyDown={vm.handleOnKeyDown}
                    />

                  </Col>
                </>
              }
            </Row>
            <Row>
              <Col xs={12} className='d-flex flex-column align-items-end'>
                <Input
                  label="Qperf (cfs) ="
                  idAndName="q-perf"
                  ariaLabel="q perf (cfs)"
                  valid={true}
                  value={vm.SurfaceInletDrainageFormData.riserPerforations.qPerf}
                  onChange={() => { }}
                  wrapperClassName='calculated-middle'
                  className="usa-input border-0"
                  type="text"
                  readOnly
                />
                <button disabled={vm.disableComputeBtn} className="usa-button sub-btns" data-testid="input-container-button" onClick={() => vm.calSurfaceInletStaging(3)}>
                  Calculate Riser Qperf
                </button>
              </Col>
            </Row>

          </Container>
          <Row>
            <h2 className="sections-heading">Orifice Plate (Optional)</h2>
            <CustomInput
              id="useOrifice"
              type="switch"
              className={`checkbox-input-switch${vm.SurfaceInletDrainageFormData.orificePlate.useOrifice ? ' selected' : ''}`}
              label="Use Orifice"
              checked={vm.SurfaceInletDrainageFormData.orificePlate.useOrifice}
              name="useOrifice"
              bsSize="lg"
              onChange={(e) => {
                vm.toggleEnableDisableInputs(e.target.name);
              }}
            />
          </Row>
          <Container className='orifice-plate-section-container'>
            {vm.SurfaceInletDrainageFormData.orificePlate.useOrifice && 
            <Row>
              <Col xs='auto' className='p-0'>
                <Input
                  label="Orifice Depth (in)"
                  idAndName="orifice-depth"
                  valid={!vm.formValidation.orificePlate.orificeDepth}
                  value={vm.SurfaceInletDrainageFormData.orificePlate.orificeDepth}
                  type="number"
                  onChange={(e) => {
                    vm.handleInputChange(e);
                  }}
                  step={0.01}
                  onBlur={(e) => vm.validateInput(e.target.name, e.target.value)}
                  className={vm.SurfaceInletDrainageErrorClass('orificeDepth')}
                  wrapperClassName='orifice-depth-input'
                  onKeyDown={vm.handleOnKeyDown}
                  min={0}
                />
              </Col>
              <Col xs={4}>
                <Input
                  label="Diameter (in)"
                  idAndName="diameter"
                  valid={!vm.formValidation.orificePlate.diameter}
                  value={vm.SurfaceInletDrainageFormData.orificePlate.diameter}
                  type="number"
                  onChange={(e) => {
                    vm.handleInputChange(e);
                  }}
                  step={0.01}
                  onBlur={(e) => vm.validateInput(e.target.name, e.target.value)}
                  className={vm.SurfaceInletDrainageErrorClass('diameter')}
                  onKeyDown={vm.handleOnKeyDown}
                  min={0}
                />
              </Col>
              <Col xs={4} className="pl-5">
                <Checkbox
                  id="userDefinedSize"
                  classAdmin="checkbox-input-formulas"
                  label="User-Defined Size"
                  checked={vm.SurfaceInletDrainageFormData.orificePlate.userDefinedSize}
                  name="userDefinedSize"
                  onChange={(e) => {
                    vm.toggleEnableDisableInputs(e.target.name);
                  }}
                />
              </Col>
            </Row>}
            <Row>
              <Col xs={12} className='d-flex flex-column align-items-end'>

                {vm.SurfaceInletDrainageFormData.orificePlate.useOrifice
                  &&
                  <>
                    {vm.SurfaceInletDrainageFormData.orificePlate.qOrifice !== '' ?
                      <Input
                        label="Qorifice (cfs) ="
                        idAndName="q-orifice"
                        ariaLabel="q orifice (cfs)"
                        valid={true}
                        value={vm.SurfaceInletDrainageFormData.orificePlate.qOrifice}
                        onChange={() => { }}
                        wrapperClassName='calculated-middle'
                        className="usa-input border-0"
                        type="text"
                        readOnly
                      /> : <input readOnly={true} value={'No Orifice Plate'} className="usa-input no-offset-input border-0"></input>
                    }
                  </>}
                <button className="usa-button sub-btns" data-testid="input-container-button" disabled={!vm.SurfaceInletDrainageFormData.orificePlate.useOrifice || vm.disableComputeBtn} onClick={() => vm.calSurfaceInletStaging(4)}>
                  Calculate Orifice
                </button>

              </Col>
            </Row>
          </Container>
          <Row>
            <h2 className="sections-heading">Offset Pipe (Optional)</h2>
            <CustomInput
              id="useOffset"
              type="switch"
              className={`checkbox-input-switch${vm.SurfaceInletDrainageFormData.offsetPipe.useOffset ? ' selected' : ''}`}
              label="Use Offset"
              bsSize="lg"
              checked={vm.SurfaceInletDrainageFormData.offsetPipe.useOffset}
              name="useOffset"
              onChange={(e) => {
                vm.toggleEnableDisableInputs(e.target.name);
              }}
            />
          </Row>
          <Container className='offset-pipe-container'>
            {vm.SurfaceInletDrainageFormData.offsetPipe.useOffset && <>
              <Row>
                <Col xs={6}>
                  <Input
                    label="Offset Length (ft)"
                    idAndName="offset-length"
                    valid={!vm.formValidation.offsetPipe.offsetLength}
                    value={vm.SurfaceInletDrainageFormData.offsetPipe.offsetLength}
                    type="number"
                    onChange={(e) => {
                      vm.handleInputChange(e);
                    }}
                    step={0.01}
                    onBlur={(e) => vm.validateInput(e.target.name, e.target.value)}
                    className={vm.SurfaceInletDrainageErrorClass('offsetLength')}
                    onKeyDown={vm.handleOnKeyDown}
                    min={0}
                  />
                </Col>
                <Col xs={6}>
                  <Input
                    label="Elbow Elevation (ft)"
                    idAndName="elbow-elevation"
                    valid={!vm.formValidation.offsetPipe.elbowElevation}
                    value={vm.SurfaceInletDrainageFormData.offsetPipe.elbowElevation}
                    type="number"
                    onChange={(e) => {
                      vm.handleInputChange(e);
                    }}
                    step={0.01}
                    onBlur={(e) => vm.validateInput(e.target.name, e.target.value)}
                    className={vm.SurfaceInletDrainageErrorClass('elbowElevation')}
                    onKeyDown={vm.handleOnKeyDown}
                    min={0}
                  />
                </Col>
              </Row>
              <Row>
                <Col xs={7}>
                  <ComboBox
                    idAndName="op-material"
                    label="Material"
                    aria-label="material"
                    valid={!vm.formValidation.offsetPipe.opMaterial}
                    value={vm.SurfaceInletDrainageFormData.offsetPipe.opMaterial}
                    onChange={(e) => {
                      vm.handleInputChange(e);
                    }}
                    onBlur={(e) => vm.validateInput(e.target.name, e.target.value)}
                    options={vm.SurfaceInletDrainageOpMaterialOptions}
                    errorMsg={''}
                    required={true}
                    className={vm.SurfaceInletDrainageErrorClass('opMaterial')}
                    wrapperName='material-input'
                  />

                </Col>
                <Col xs={5} className='p-0'>
                  <Checkbox
                    id="op-perforated"
                    classAdmin="checkbox-input-formulas"
                    label="Perforated"
                    checked={vm.SurfaceInletDrainageFormData.offsetPipe.opPerforated}
                    name="op-perforated"
                    onChange={(e) => {
                      vm.toggleEnableDisableInputs(e.target.name);
                    }}
                  />
                </Col>
              </Row>
              <Row>
                <Col xs={7}>
                  {vm.SurfaceInletDrainageFormData.offsetPipe.opMaterial === 'USER_DEFINED' ?
                    <Input
                      label="Pipe Size (in)"
                      idAndName="op-pipe-size-box"
                      valid={!vm.formValidation.offsetPipe.opPipeSize}
                      value={vm.SurfaceInletDrainageFormData.offsetPipe.opPipeSize}
                      type="number"
                      onChange={(e) => {
                        vm.handleInputChange(e);
                      }}
                      step={0.01}
                      onBlur={(e) => vm.validateInput(e.target.name, e.target.value)}
                      className={vm.SurfaceInletDrainageErrorClass('opPipeSize')}
                      wrapperClassName='pipe-size-input'
                      onKeyDown={vm.handleOnKeyDown}
                      min={0}
                    />
                    : <ComboBox
                      idAndName="op-pipe-size"
                      label="Pipe Size (in)"
                      aria-label="pipe size"
                      valid={!vm.formValidation.offsetPipe.opPipeSize}
                      value={vm.SurfaceInletDrainageFormData.offsetPipe.opPipeSize}
                      onChange={(e) => {
                        vm.handleInputChange(e);
                      }}
                      onBlur={(e) => vm.validateInput(e.target.name, e.target.value)}
                      options={vm.SurfaceInletDrainageOpPipesizeOptions}
                      errorMsg={''}
                      required={true}
                      className={vm.SurfaceInletDrainageErrorClass('opPipeSize')}
                      wrapperName='pipe-size-input'
                    />}
                </Col>
                <Col xs={5} className='p-0'>
                  <Checkbox
                    id="op-pressurizable"
                    classAdmin="checkbox-input-formulas"
                    label="Pressurizable"
                    checked={vm.SurfaceInletDrainageFormData.offsetPipe.opPressurizable}
                    name="op-pressurizable"
                    onChange={(e) => {
                      vm.toggleEnableDisableInputs(e.target.name);
                    }}
                  />
                </Col>
              </Row>
              <Row>
                <Col xs={6}>
                  <Input
                    label="Manning's n"
                    idAndName="op-manningsn"
                    valid={!vm.formValidation.offsetPipe.opManningsn}
                    value={vm.SurfaceInletDrainageFormData.offsetPipe.opManningsn}
                    type="number"
                    onChange={(e) => {
                      vm.handleInputChange(e);
                    }}
                    step={0.0001}
                    onBlur={(e) => vm.validateInput(e.target.name, e.target.value)}
                    className={vm.SurfaceInletDrainageErrorClass('opManningsn')}
                    onKeyDown={vm.handleOnKeyDown}
                    min={0}
                    disabled={!vm.SurfaceInletDrainageFormData.offsetPipe.useOffset}
                  />
                </Col>
              </Row>
            </>}
            <Row>
              <Col xs={12} className='d-flex flex-column align-items-end'>
              {vm.SurfaceInletDrainageFormData.offsetPipe.useOffset
                  &&
                  <>
                    {vm.SurfaceInletDrainageFormData.offsetPipe.qOffset !== '' ?
                      <Input
                      label="Qoffset (cfs) ="
                      idAndName="q-offset"
                      ariaLabel="q offset (cfs)"
                      valid={true}
                      value={vm.SurfaceInletDrainageFormData.offsetPipe.qOffset}
                      onChange={() => { }}
                      wrapperClassName='calculated-middle'
                      className="usa-input border-0"
                      type="text"
                      readOnly
                    />  : <input readOnly={true} value={'No offset pipe'} className="usa-input no-offset-input border-0"></input>
                    }
                  </>}
                <button className="usa-button sub-btns" data-testid="input-container-button" disabled={!vm.SurfaceInletDrainageFormData.offsetPipe.useOffset || vm.disableComputeBtn} onClick={() => vm.calSurfaceInletStaging(5)}>
                  Calculate Offset
                </button>
              </Col>
            </Row>
          </Container>
        </InputContainer>

        <div className="col formula-information formula-information-surface-inlet">
          {vm.hasResults ? (
            <div className="row formula-results">
              <ResultsContainer>
                <div className="col result-value-group">
                  <ul className="usa-list--unstyled">
                    {vm.SurfaceInletDrainageResults?.map((item, index) => (
                      <li key={`${item.label}-${index}`} className="row">
                        <span className='col-auto result-label'>{index < 2 ? item.label + ' (cfs):' : item.label + ':'}</span>
                        <span className='col-auto result-value'>{item.value}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              </ResultsContainer>
            </div>
          ) : null}
          <div className="row formula-description">
            <DescriptionContainer>
              <p>
                {vm.formDescription}
                &nbsp;
                <a target="_blank" href={vm.bannerHelpLink}>
                  Learn More
                  <img src={pdfLogo} alt={'PDF logo'} />
                </a>
              </p>
            </DescriptionContainer>
          </div>
          <div className="row formula-images">
            <ImageContainer>
              {vm.image ? (
                <img
                  className="SurfaceInletDrainage-img"
                  src={vm.image}
                  alt={vm.hydraulicFormulaImageDescription}
                  title={vm.formulaTitle}
                />
              ) : null}
            </ImageContainer>
          </div>
        </div>
        {vm.isLoading && <Loader message={''} />}
      </div>
      <FormulaPrintModalContainer
        vm={vm}
        inputs={vm.exportedInputs}
        results={vm.exportedResults}
        images={[vm.image]}
        formulaName={vm.formulaTitle}
      />
    </Fragment>
  );
};

export const SurfaceInletDrainageFormula = observer(SurfaceInletDrainageComponent);
